import { addFiles } from './clips.ts';
import { notify, state } from './state.ts';

/** Explicit two-URL intake. Local disk paths require the loopback review server. */
export async function loadComparisonParameters(): Promise<void> {
  const params = new URLSearchParams(location.search);
  if (!params.has('before') && !params.has('after')) return;
  const status = document.createElement('p');
  status.setAttribute('role', 'status');
  document.querySelector('#sidebar')?.prepend(status);
  try {
    const before = params.get('before');
    const after = params.get('after');
    if (!before || !after) throw new Error('Both before and after parameters are required.');
    const urls = [before, after].map((value) => {
      const url = new URL(value, location.href);
      if (!['http:', 'https:'].includes(url.protocol)) {
        throw new Error('Use HTTP(S) URLs or launch the local review server; file paths are not accessible to a web page.');
      }
      return url;
    });
    status.textContent = 'Loading original and repaired clips…';
    const files = await Promise.all(urls.map(async (url, index) => {
      const response = await fetch(url, { credentials: 'same-origin', signal: AbortSignal.timeout(120000) });
      if (!response.ok) throw new Error(`Clip ${index + 1}: HTTP ${response.status}`);
      const blob = await response.blob();
      const name = decodeURIComponent(url.pathname.split('/').pop() || 'video.mp4');
      if (!/\.(mp4|mov|m4v|webm)$/i.test(name)) throw new Error('Comparison links must point to video files, not a Drive share page.');
      return new File([blob], `${index === 0 ? 'BEFORE' : 'AFTER'}-${name}`, { type: blob.type || 'video/mp4' });
    }));
    await addFiles(files);
    if (state.clips.length !== 2) throw new Error('One or both videos could not be decoded.');
    state.layout = 'side-by-side';
    notify();
    status.textContent = 'Original ← | → Repaired. Aligned at t=0; no retiming. Press Play to inspect motion.';
  } catch (error) {
    status.textContent = `Comparison not loaded: ${error instanceof Error ? error.message : 'unknown error'}`;
  }
}
